import type { RoomSnapshot } from '@xox/shared'
import type { Effect } from '../lib/feedback'
import { createDuelStore, type DuelView } from './duel'

export type RoomView = DuelView<RoomSnapshot>

/** A new mark, plus `vanish` when one of the previous marks is gone. */
export function xoxMoveEffects(a: RoomSnapshot, b: RoomSnapshot): Effect[] {
  const out: Effect[] = ['place']
  if (a.game.board.some((m, i) => m !== null && b.game.board[i] === null)) out.push('vanish')
  return out
}

/** Vanishing XOX rooms. */
export const useRoom = createDuelStore<RoomSnapshot>({
  wsPath: '/ws',
  moveMessage: (cell, expectedSeq) => ({ type: 'move', cell, expectedSeq }),
  canMove: (snap, cell) => snap.game.board[cell] === null,
  moveEffects: xoxMoveEffects,
})

export function serverNow(): number {
  return Date.now() + useRoom.getState().clockOffset
}
